module.exports = __webpack_public_path__ + "img/28.02ca972e.jpg";